import { Injectable } from '@angular/core';

import { Oauth2Service } from '@common';
import { Observable, from as observableFrom } from 'rxjs';

import { ContextInterface } from '../context.interface';
import { ContextService } from '../context.service';

export enum USER_ENS_TYPE {
    CA = 499,
    CS = 993,
    CM = 400,
}

@Injectable({
    providedIn: 'root',
})
export class UserContextService implements ContextInterface {
    public keySerialize: string = 'UserContextService';
    public firstname: string;
    public lastname: string;
    public idPersonne: string;
    public user_type: string;
    public roles: string;
    public login: string;
    public codePdv: string;
    public codeEns: string;
    public nomBoutique: string = '';

    constructor(private oauth2Service: Oauth2Service) {}

    public serialize(): { [index: string]: any } {
        return {};
    }

    public create(): Observable<UserContextService> {
        const intance: UserContextService = new UserContextService(this.oauth2Service);
        return intance.config();
    }

    public updateContext(contextService: ContextService): Observable<ContextService> {
        return observableFrom([contextService]);
    }

    public config(): Observable<UserContextService> {
        this.firstname = this.oauth2Service.jwtPayload.name;
        if (this.oauth2Service.jwtPayload.site) {
            this.codePdv = this.oauth2Service.jwtPayload.site.substring(0, 3);
            this.codeEns = this.oauth2Service.jwtPayload.site.substring(3);
        }

        if (this.oauth2Service.jwtPayload.enseigne) {
            this.codeEns = this.oauth2Service.jwtPayload.enseigne;
        }

        if (this.oauth2Service.jwtPayload.point_vente) {
            this.codePdv = this.oauth2Service.jwtPayload.point_vente;
        }

        this.login = this.oauth2Service.jwtPayload.login;
        return observableFrom([this]);
    }

    public isPremiumForPromo(): boolean {
        return false;
    }

    public isStandardForPromo(): boolean {
        return false;
    }
}
